import { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

import { AREA_CODE_OPTIONS as AREA_CODES } from '~/models/area'

// STATUS_BADGE_LABEL_KEYS は共通モジュールからの re-export（ProcurementPlanList 固有の
// ロジックは無い。deriveStatusBadge 等と同じく ~/models/planSubmission/statusBadge に集約）。
export { STATUS_BADGE_LABEL_KEYS } from '~/models/planSubmission/statusBadge'

// 断面タブ撤去 (procurement-plan-list-three-section 設計 §5) により一覧画面は
// timeframe を指定せず全断面を横断表示する (計画作成ダイアログの断面 UI は
// procurement-create-dialog-section-target-date-approval 設計により「当日・翌日・翌々日」
// の単一固定ラベルへ統合済み (#7149 で当日を追加) で、一覧タブとの同期概念は既に無い)。

/**
 * 計画期間タブ (procurement-plan-list-period-tab 設計 Decision #2)。
 * 本 slice の対象は「日次」タブの中身のみで、週間/月間/年間はタブ切替のみで中身は
 * 未対応 (別 spec)。「日次」= 既存の 3 断面 (翌日(当日)/翌日/翌々日) を横断する
 * UI 概念のため、日次選択時の API 呼び出しは timeframe 未指定で 3 断面横断取得する
 * (proto `PlanTimeframe` の TODAY/TOMORROW/DAY_AFTER_TOMORROW に個別に写像しない)。
 * 週間/月間/年間の中身の実装時は proto の WEEKLY/MONTHLY/ANNUAL への写像を導入する
 * (本 slice では未使用)。
 *
 * `as const` + `(typeof X)[number]` により定数配列と型が単一 SoT で連動する
 * (どちらか片方だけを増減させる drift を型エラーで防ぐ)。
 */
export const PERIOD_TAB_KEYS = ['daily', 'weekly', 'monthly', 'annual'] as const

export type PeriodTabKey = (typeof PERIOD_TAB_KEYS)[number]

export const DEFAULT_PERIOD_TAB: PeriodTabKey = 'daily'

/**
 * エリアフィルタ (複数選択) select の value ↔ AreaCode 対応表。
 *
 * ラベルはここでは持たず、render 時に convertAreaLabel で解決する (= 表示は呼び出し側)。
 * module-load 時に convertAreaLabel を呼ぶと i18next 未初期化で全ラベルが undefined に
 * 固定化され、react-select のフィルタ (= 内部で label.replace) が undefined.replace で
 * 落ちて「エリアが選択できない」事故になるため (= 他のエリア select 画面と同じく
 * render 時にラベル解決する canonical パターンに合わせる)。
 *
 * 複数選択化 (procurement-plan-list-area-multi-select 設計) により「全エリア」
 * は select の pseudo option ではなく専用ボタン (AC-016) が担うため、
 * UNSPECIFIED は選択肢に含めない (= 実エリア 10 個のみ、北→南の canonical 順)。
 */
export const AREA_CODE_OPTIONS: Array<{
  value: string
  areaCode: AreaCode
}> = AREA_CODES.map((areaCode) => ({
  value: String(areaCode),
  areaCode,
}))
